import { Navigate, useParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { isStaffRole } from "@lms/backend/lib/auth/post-login-redirect";
import { NotificationCentre } from "@/components/notification-centre";
import { useAuthStore } from "@/stores/authStore";

export function TenantNotificationsPage() {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const t = useTranslations("notifications");
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to={`/t/${tenantSlug}/login`} replace />;
  }

  return (
    <main className="mx-auto max-w-3xl px-4 py-10">
      <h1 className="text-2xl font-semibold">{t("title")}</h1>
      <div className="mt-6">
        <NotificationCentre isStaff={isStaffRole(user?.role)} />
      </div>
    </main>
  );
}
